export default {"src":"/_next/static/media/advanced-persistent-threat.f5145669.svg","height":278,"width":348,"blurWidth":0,"blurHeight":0};